export default {
  'containers/pageset': { items: [] },
  'containers/columns': { items: [] },
  'containers/list': { items: [] },
  'containers/tabset': { items: [] },
  'containers/workspace': { items: [] },
  'media/image': { src: 'url...', alt: 'text...' },
  'media/rich_text': {
    content: { type: 'doc', content: [{ type: 'paragraph' }] },
  },
  'media/video': {
    srcs: ['url...'],
    transcript: 'text...',
    captions: 'url...',
  },
  'media/youtube': { src: 'url...', transcript: 'text...', captions: 'url...' },
  'media/audio': { src: 'url...' },
  'media/wistia': { key: 'video key...' },
  'questions/essay_score': {
    prompt: '',
    answers: [{ value: 0, description: '' }],
  },
  'questions/multiple_choice': { question: '', answers: [{}, {}] },
  'questions/multiple_choice_multiple_answer': { question: '', answers: [''] },
  'questions/free_response': {
    prompt: '',
    answer_space: 'medium',
    scoring: [{ scores: [{}, {}] }],
  },
  'cb/pl/articulate': { src: '..._html5.html' },
  'survey/multiple_choice': { question: '', answers: [] },
  'survey/text_response': { question: '' },
  'composite/quiz': { items: [] },
  'composite/question_set': { items: [] },
};
